/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------

import axios, { AxiosRequestConfig, AxiosPromise, AxiosInstance } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

interface ClientApiConfig {
    baseUrl: string;
    axios: AxiosInstance;
}

export const BASE_URL_TOKEN_TelecomApi = symbolToken<string>('BASE_URL_TOKEN', false);
export const AXIOS_TOKEN_TelecomApi = symbolToken<string>('AXIOS_TOKEN', false);

@injectable()
export class TelecomApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    protected readonly opts: ClientApiConfig;

    constructor(
        @inject(BASE_URL_TOKEN_TelecomApi) @optional() baseUrl = '',
        @inject(AXIOS_TOKEN_TelecomApi) @optional() axiosInstance = axios,
    ) {

        this.opts = {
            baseUrl,
            axios: axiosInstance,
        };
    }

    /**
     * @return Success
     */
    brands(x_TenantId: any, x_PartnerId: any, signal?: AbortSignal): AxiosPromise<TelecomBrandData[]> {
        let url_ = "/api/TelecomManagement/Brands";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "GET",
            headers: {
                "X-TenantId": x_TenantId !== undefined && x_TenantId !== null ? "" + x_TenantId : "",
                "X-PartnerId": x_PartnerId !== undefined && x_PartnerId !== null ? "" + x_PartnerId : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.opts.axios.request<TelecomBrandData[]>(options_);
    }

    /**
     * @return Success
     */
    ownersGET(id: number, ownerId: number, x_TenantId: any, x_PartnerId: any, signal?: AbortSignal): AxiosPromise<TelecomBrandData> {
        let url_ = "/api/TelecomManagement/Brands/{Id}/owners/{OwnerId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (ownerId === undefined || ownerId === null)
            throw new Error("The parameter 'ownerId' must be defined.");
        url_ = url_.replace("{OwnerId}", encodeURIComponent("" + ownerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "GET",
            headers: {
                "X-TenantId": x_TenantId !== undefined && x_TenantId !== null ? "" + x_TenantId : "",
                "X-PartnerId": x_PartnerId !== undefined && x_PartnerId !== null ? "" + x_PartnerId : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.opts.axios.request<TelecomBrandData>(options_);
    }

    /**
     * @return Success
     */
    ownersDELETE(id: number, ownerId: number, x_TenantId: any, x_PartnerId: any, signal?: AbortSignal): AxiosPromise<void> {
        let url_ = "/api/TelecomManagement/Brands/{Id}/owners/{OwnerId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (ownerId === undefined || ownerId === null)
            throw new Error("The parameter 'ownerId' must be defined.");
        url_ = url_.replace("{OwnerId}", encodeURIComponent("" + ownerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "DELETE",
            headers: {
                "X-TenantId": x_TenantId !== undefined && x_TenantId !== null ? "" + x_TenantId : "",
                "X-PartnerId": x_PartnerId !== undefined && x_PartnerId !== null ? "" + x_PartnerId : "",
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    /**
     * @page (optional) 
     * @pageSize (optional) 
     * @isAscending (optional) 
     * @sortingField (optional) 
     * @phoneNumberSearch (optional) 
     * @optOutFilterType (optional) 
     * @return Success
     */
    globalOptInOutsGET(page: number | undefined, pageSize: number | undefined, isAscending: boolean | undefined, sortingField: string | undefined, phoneNumberSearch: string | undefined, optOutFilterType: OptOutFilterType | undefined, x_TenantId: any, x_PartnerId: any, signal?: AbortSignal): AxiosPromise<GlobalOptInOutPaginationResult> {
        let url_ = "/api/TelecomManagement/GlobalOptInOuts?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (isAscending === null)
            throw new Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "IsAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (sortingField === null)
            throw new Error("The parameter 'sortingField' cannot be null.");
        else if (sortingField !== undefined)
            url_ += "SortingField=" + encodeURIComponent("" + sortingField) + "&";
        if (phoneNumberSearch === null)
            throw new Error("The parameter 'phoneNumberSearch' cannot be null.");
        else if (phoneNumberSearch !== undefined)
            url_ += "PhoneNumberSearch=" + encodeURIComponent("" + phoneNumberSearch) + "&";
        if (optOutFilterType === null)
            throw new Error("The parameter 'optOutFilterType' cannot be null.");
        else if (optOutFilterType !== undefined)
            url_ += "OptOutFilterType=" + encodeURIComponent("" + optOutFilterType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "GET",
            headers: {
                "X-TenantId": x_TenantId !== undefined && x_TenantId !== null ? "" + x_TenantId : "",
                "X-PartnerId": x_PartnerId !== undefined && x_PartnerId !== null ? "" + x_PartnerId : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.opts.axios.request<GlobalOptInOutPaginationResult>(options_);
    }

    globalOptInOutsPATCH(x_TenantId: any, x_PartnerId: any, body: UpdateGlobalOptInOutRequest | undefined, signal?: AbortSignal): AxiosPromise<void> {
        let url_ = "/api/TelecomManagement/GlobalOptInOuts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            data: content_,
            url: url_,
            method: "PATCH",
            headers: {
                "X-TenantId": x_TenantId !== undefined && x_TenantId !== null ? "" + x_TenantId : "",
                "X-PartnerId": x_PartnerId !== undefined && x_PartnerId !== null ? "" + x_PartnerId : "",
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    /**
     * @page (optional) 
     * @pageSize (optional) 
     * @isAscending (optional) 
     * @sortingField (optional) 
     * @searchQuery (optional) 
     * @status (optional) 
     * @priority (optional) 
     * @dateFrom (optional) 
     * @dateTo (optional) 
     * @return Success
     */
    outboundMessages(page: number | undefined, pageSize: number | undefined, isAscending: boolean | undefined, sortingField: string | undefined, searchQuery: string | undefined, status: MessageStatus[] | undefined, priority: Priority | undefined, dateFrom: Date | undefined, dateTo: Date | undefined, x_TenantId: any, x_PartnerId: any, signal?: AbortSignal): AxiosPromise<OutboundMessagePaginationResult> {
        let url_ = "/api/TelecomManagement/OutboundMessages?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (isAscending === null)
            throw new Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "IsAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (sortingField === null)
            throw new Error("The parameter 'sortingField' cannot be null.");
        else if (sortingField !== undefined)
            url_ += "SortingField=" + encodeURIComponent("" + sortingField) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (priority === null)
            throw new Error("The parameter 'priority' cannot be null.");
        else if (priority !== undefined)
            url_ += "Priority=" + encodeURIComponent("" + priority) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "GET",
            headers: {
                "X-TenantId": x_TenantId !== undefined && x_TenantId !== null ? "" + x_TenantId : "",
                "X-PartnerId": x_PartnerId !== undefined && x_PartnerId !== null ? "" + x_PartnerId : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.opts.axios.request<OutboundMessagePaginationResult>(options_);
    }

    /**
     * @page (optional) 
     * @pageSize (optional) 
     * @isAscending (optional) 
     * @sortingField (optional) 
     * @phoneNumberSearch (optional) 
     * @return Success
     */
    phoneNumbersGET(page: number | undefined, pageSize: number | undefined, isAscending: boolean | undefined, sortingField: string | undefined, phoneNumberSearch: string | undefined, x_TenantId: any, x_PartnerId: any, signal?: AbortSignal): AxiosPromise<TelecomPhoneNumberPaginationResult> {
        let url_ = "/api/TelecomManagement/PhoneNumbers?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (isAscending === null)
            throw new Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "IsAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (sortingField === null)
            throw new Error("The parameter 'sortingField' cannot be null.");
        else if (sortingField !== undefined)
            url_ += "SortingField=" + encodeURIComponent("" + sortingField) + "&";
        if (phoneNumberSearch === null)
            throw new Error("The parameter 'phoneNumberSearch' cannot be null.");
        else if (phoneNumberSearch !== undefined)
            url_ += "PhoneNumberSearch=" + encodeURIComponent("" + phoneNumberSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "GET",
            headers: {
                "X-TenantId": x_TenantId !== undefined && x_TenantId !== null ? "" + x_TenantId : "",
                "X-PartnerId": x_PartnerId !== undefined && x_PartnerId !== null ? "" + x_PartnerId : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.opts.axios.request<TelecomPhoneNumberPaginationResult>(options_);
    }

    phoneNumbersPATCH(x_TenantId: any, x_PartnerId: any, body: UpdatePhoneRequest | undefined, signal?: AbortSignal): AxiosPromise<void> {
        let url_ = "/api/TelecomManagement/PhoneNumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            data: content_,
            url: url_,
            method: "PATCH",
            headers: {
                "X-TenantId": x_TenantId !== undefined && x_TenantId !== null ? "" + x_TenantId : "",
                "X-PartnerId": x_PartnerId !== undefined && x_PartnerId !== null ? "" + x_PartnerId : "",
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    owner(ownerId: number, phoneNumberE164: string, x_TenantId: any, x_PartnerId: any, signal?: AbortSignal): AxiosPromise<void> {
        let url_ = "/api/TelecomManagement/PhoneNumbers/{PhoneNumberE164}/owner/{OwnerId}";
        if (ownerId === undefined || ownerId === null)
            throw new Error("The parameter 'ownerId' must be defined.");
        url_ = url_.replace("{OwnerId}", encodeURIComponent("" + ownerId));
        if (phoneNumberE164 === undefined || phoneNumberE164 === null)
            throw new Error("The parameter 'phoneNumberE164' must be defined.");
        url_ = url_.replace("{PhoneNumberE164}", encodeURIComponent("" + phoneNumberE164));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "DELETE",
            headers: {
                "X-TenantId": x_TenantId !== undefined && x_TenantId !== null ? "" + x_TenantId : "",
                "X-PartnerId": x_PartnerId !== undefined && x_PartnerId !== null ? "" + x_PartnerId : "",
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }
}

export class GlobalOptInOut implements IGlobalOptInOut {
    phoneNumberE164!: string | null;
    isOptedOut!: boolean;
    ownerId!: number;

    constructor(data?: IGlobalOptInOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumberE164 = _data["phoneNumberE164"] !== undefined ? _data["phoneNumberE164"] : <any>null;
            this.isOptedOut = _data["isOptedOut"] !== undefined ? _data["isOptedOut"] : <any>null;
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
        }
    }

    static fromJS(data: any): GlobalOptInOut {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalOptInOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumberE164"] = this.phoneNumberE164 !== undefined ? this.phoneNumberE164 : <any>null;
        data["isOptedOut"] = this.isOptedOut !== undefined ? this.isOptedOut : <any>null;
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        return data;
    }
}

export interface IGlobalOptInOut {
    phoneNumberE164: string | null;
    isOptedOut: boolean;
    ownerId: number;
}

export class GlobalOptInOutPaginationResult implements IGlobalOptInOutPaginationResult {
    items!: GlobalOptInOut[] | null;
    count!: number;

    constructor(data?: IGlobalOptInOutPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GlobalOptInOut.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
        }
    }

    static fromJS(data: any): GlobalOptInOutPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalOptInOutPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        data["count"] = this.count !== undefined ? this.count : <any>null;
        return data;
    }
}

export interface IGlobalOptInOutPaginationResult {
    items: GlobalOptInOut[] | null;
    count: number;
}

export class MarketingBrand implements IMarketingBrand {
    id!: string | null;
    name!: string | null;

    constructor(data?: IMarketingBrand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): MarketingBrand {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingBrand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IMarketingBrand {
    id: string | null;
    name: string | null;
}

export enum MessageStatus {
    Scheduled = 0,
    Sent = 1,
    SendingError = 2,
    Delivered = 3,
    DeliveryError = 4,
    Sending = 5,
}

export enum OptOutFilterType {
    All = 0,
    OptedIn = 1,
    OptedOut = 2,
}

export class OutboundMessage implements IOutboundMessage {
    id!: number;
    recipientNumberE164!: string | null;
    text!: string | null;
    dateCreated!: Date;
    messageType!: string | null;
    messageStatus!: MessageStatus;
    messageSid!: string | null;
    senderNumberE164!: string | null;
    dateSent!: Date | null;
    priority!: Priority;
    mediaUrls!: string[] | null;
    errorMessage!: string | null;

    constructor(data?: IOutboundMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.recipientNumberE164 = _data["recipientNumberE164"] !== undefined ? _data["recipientNumberE164"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>null;
            this.messageType = _data["messageType"] !== undefined ? _data["messageType"] : <any>null;
            this.messageStatus = _data["messageStatus"] !== undefined ? _data["messageStatus"] : <any>null;
            this.messageSid = _data["messageSid"] !== undefined ? _data["messageSid"] : <any>null;
            this.senderNumberE164 = _data["senderNumberE164"] !== undefined ? _data["senderNumberE164"] : <any>null;
            this.dateSent = _data["dateSent"] ? new Date(_data["dateSent"].toString()) : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            if (Array.isArray(_data["mediaUrls"])) {
                this.mediaUrls = [] as any;
                for (let item of _data["mediaUrls"])
                    this.mediaUrls!.push(item);
            }
            else {
                this.mediaUrls = <any>null;
            }
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : <any>null;
        }
    }

    static fromJS(data: any): OutboundMessage {
        data = typeof data === 'object' ? data : {};
        let result = new OutboundMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["recipientNumberE164"] = this.recipientNumberE164 !== undefined ? this.recipientNumberE164 : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>null;
        data["messageType"] = this.messageType !== undefined ? this.messageType : <any>null;
        data["messageStatus"] = this.messageStatus !== undefined ? this.messageStatus : <any>null;
        data["messageSid"] = this.messageSid !== undefined ? this.messageSid : <any>null;
        data["senderNumberE164"] = this.senderNumberE164 !== undefined ? this.senderNumberE164 : <any>null;
        data["dateSent"] = this.dateSent ? this.dateSent.toISOString() : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        if (Array.isArray(this.mediaUrls)) {
            data["mediaUrls"] = [];
            for (let item of this.mediaUrls)
                data["mediaUrls"].push(item);
        }
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        return data;
    }
}

export interface IOutboundMessage {
    id: number;
    recipientNumberE164: string | null;
    text: string | null;
    dateCreated: Date;
    messageType: string | null;
    messageStatus: MessageStatus;
    messageSid: string | null;
    senderNumberE164: string | null;
    dateSent: Date | null;
    priority: Priority;
    mediaUrls: string[] | null;
    errorMessage: string | null;
}

export class OutboundMessagePaginationResult implements IOutboundMessagePaginationResult {
    items!: OutboundMessage[] | null;
    count!: number;

    constructor(data?: IOutboundMessagePaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OutboundMessage.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
        }
    }

    static fromJS(data: any): OutboundMessagePaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new OutboundMessagePaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        data["count"] = this.count !== undefined ? this.count : <any>null;
        return data;
    }
}

export interface IOutboundMessagePaginationResult {
    items: OutboundMessage[] | null;
    count: number;
}

export enum Priority {
    Low = 0,
    Normal = 1,
    High = 2,
    Urgent = 3,
}

export class ProblemDetails implements IProblemDetails {
    type!: string | null;
    title!: string | null;
    status!: number | null;
    detail!: string | null;
    instance!: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        return data;
    }
}

export interface IProblemDetails {
    type: string | null;
    title: string | null;
    status: number | null;
    detail: string | null;
    instance: string | null;

    [key: string]: any;
}

export class TelecomBrandData implements ITelecomBrandData {
    status!: TelecomBrandStatus;
    message!: string | null;
    id!: number;
    createdOn!: Date;
    modifiedOn!: Date;
    submittedOn!: Date | null;
    scoredOn!: Date | null;
    details!: TelecomBrandDetails;
    marketingBrands!: MarketingBrand[] | null;
    campaigns!: TelecomCampaignDetails[] | null;
    ownerId!: number;

    constructor(data?: ITelecomBrandData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>null;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>null;
            this.submittedOn = _data["submittedOn"] ? new Date(_data["submittedOn"].toString()) : <any>null;
            this.scoredOn = _data["scoredOn"] ? new Date(_data["scoredOn"].toString()) : <any>null;
            this.details = _data["details"] ? TelecomBrandDetails.fromJS(_data["details"]) : <any>null;
            if (Array.isArray(_data["marketingBrands"])) {
                this.marketingBrands = [] as any;
                for (let item of _data["marketingBrands"])
                    this.marketingBrands!.push(MarketingBrand.fromJS(item));
            }
            else {
                this.marketingBrands = <any>null;
            }
            if (Array.isArray(_data["campaigns"])) {
                this.campaigns = [] as any;
                for (let item of _data["campaigns"])
                    this.campaigns!.push(TelecomCampaignDetails.fromJS(item));
            }
            else {
                this.campaigns = <any>null;
            }
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
        }
    }

    static fromJS(data: any): TelecomBrandData {
        data = typeof data === 'object' ? data : {};
        let result = new TelecomBrandData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>null;
        data["submittedOn"] = this.submittedOn ? this.submittedOn.toISOString() : <any>null;
        data["scoredOn"] = this.scoredOn ? this.scoredOn.toISOString() : <any>null;
        data["details"] = this.details ? this.details.toJSON() : <any>null;
        if (Array.isArray(this.marketingBrands)) {
            data["marketingBrands"] = [];
            for (let item of this.marketingBrands)
                data["marketingBrands"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.campaigns)) {
            data["campaigns"] = [];
            for (let item of this.campaigns)
                data["campaigns"].push(item ? item.toJSON() : <any>null);
        }
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        return data;
    }
}

export interface ITelecomBrandData {
    status: TelecomBrandStatus;
    message: string | null;
    id: number;
    createdOn: Date;
    modifiedOn: Date;
    submittedOn: Date | null;
    scoredOn: Date | null;
    details: TelecomBrandDetails;
    marketingBrands: MarketingBrand[] | null;
    campaigns: TelecomCampaignDetails[] | null;
    ownerId: number;
}

export class TelecomBrandDetails implements ITelecomBrandDetails {
    dbaName!: string | null;
    legalName!: string | null;
    ein!: string | null;
    phoneNumber!: string | null;
    streetAddress!: string | null;
    city!: string | null;
    state!: string | null;
    zipCode!: string | null;
    country!: string | null;
    email!: string | null;
    website!: string | null;
    isPubliclyTraded!: boolean;
    stockSymbol!: string | null;
    stockExchange!: string | null;
    altBusinessId!: string | null;
    altBusinessIdType!: string | null;

    constructor(data?: ITelecomBrandDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dbaName = _data["dbaName"] !== undefined ? _data["dbaName"] : <any>null;
            this.legalName = _data["legalName"] !== undefined ? _data["legalName"] : <any>null;
            this.ein = _data["ein"] !== undefined ? _data["ein"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.streetAddress = _data["streetAddress"] !== undefined ? _data["streetAddress"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.website = _data["website"] !== undefined ? _data["website"] : <any>null;
            this.isPubliclyTraded = _data["isPubliclyTraded"] !== undefined ? _data["isPubliclyTraded"] : <any>null;
            this.stockSymbol = _data["stockSymbol"] !== undefined ? _data["stockSymbol"] : <any>null;
            this.stockExchange = _data["stockExchange"] !== undefined ? _data["stockExchange"] : <any>null;
            this.altBusinessId = _data["altBusinessId"] !== undefined ? _data["altBusinessId"] : <any>null;
            this.altBusinessIdType = _data["altBusinessIdType"] !== undefined ? _data["altBusinessIdType"] : <any>null;
        }
    }

    static fromJS(data: any): TelecomBrandDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TelecomBrandDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dbaName"] = this.dbaName !== undefined ? this.dbaName : <any>null;
        data["legalName"] = this.legalName !== undefined ? this.legalName : <any>null;
        data["ein"] = this.ein !== undefined ? this.ein : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["streetAddress"] = this.streetAddress !== undefined ? this.streetAddress : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["website"] = this.website !== undefined ? this.website : <any>null;
        data["isPubliclyTraded"] = this.isPubliclyTraded !== undefined ? this.isPubliclyTraded : <any>null;
        data["stockSymbol"] = this.stockSymbol !== undefined ? this.stockSymbol : <any>null;
        data["stockExchange"] = this.stockExchange !== undefined ? this.stockExchange : <any>null;
        data["altBusinessId"] = this.altBusinessId !== undefined ? this.altBusinessId : <any>null;
        data["altBusinessIdType"] = this.altBusinessIdType !== undefined ? this.altBusinessIdType : <any>null;
        return data;
    }
}

export interface ITelecomBrandDetails {
    dbaName: string | null;
    legalName: string | null;
    ein: string | null;
    phoneNumber: string | null;
    streetAddress: string | null;
    city: string | null;
    state: string | null;
    zipCode: string | null;
    country: string | null;
    email: string | null;
    website: string | null;
    isPubliclyTraded: boolean;
    stockSymbol: string | null;
    stockExchange: string | null;
    altBusinessId: string | null;
    altBusinessIdType: string | null;
}

export enum TelecomBrandStatus {
    NotSynced = 0,
    ScorePending = 1,
    Active = 2,
    Removed = 3,
    VettingPending = 4,
}

export class TelecomCampaignDetails implements ITelecomCampaignDetails {
    id!: number;
    externalId!: string | null;
    useCases!: string[] | null;
    phoneNumbers!: string[] | null;

    constructor(data?: ITelecomCampaignDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            if (Array.isArray(_data["useCases"])) {
                this.useCases = [] as any;
                for (let item of _data["useCases"])
                    this.useCases!.push(item);
            }
            else {
                this.useCases = <any>null;
            }
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(item);
            }
            else {
                this.phoneNumbers = <any>null;
            }
        }
    }

    static fromJS(data: any): TelecomCampaignDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TelecomCampaignDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        if (Array.isArray(this.useCases)) {
            data["useCases"] = [];
            for (let item of this.useCases)
                data["useCases"].push(item);
        }
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item);
        }
        return data;
    }
}

export interface ITelecomCampaignDetails {
    id: number;
    externalId: string | null;
    useCases: string[] | null;
    phoneNumbers: string[] | null;
}

export class TelecomPhoneNumber implements ITelecomPhoneNumber {
    phoneNumberE164!: string | null;
    forwardingNumberE164!: string | null;
    allowIncomingMessages!: boolean | null;
    system!: string | null;
    portOutStatus!: string | null;
    authenticationName!: string | null;
    ownerId!: number;

    constructor(data?: ITelecomPhoneNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumberE164 = _data["phoneNumberE164"] !== undefined ? _data["phoneNumberE164"] : <any>null;
            this.forwardingNumberE164 = _data["forwardingNumberE164"] !== undefined ? _data["forwardingNumberE164"] : <any>null;
            this.allowIncomingMessages = _data["allowIncomingMessages"] !== undefined ? _data["allowIncomingMessages"] : <any>null;
            this.system = _data["system"] !== undefined ? _data["system"] : <any>null;
            this.portOutStatus = _data["portOutStatus"] !== undefined ? _data["portOutStatus"] : <any>null;
            this.authenticationName = _data["authenticationName"] !== undefined ? _data["authenticationName"] : <any>null;
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
        }
    }

    static fromJS(data: any): TelecomPhoneNumber {
        data = typeof data === 'object' ? data : {};
        let result = new TelecomPhoneNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumberE164"] = this.phoneNumberE164 !== undefined ? this.phoneNumberE164 : <any>null;
        data["forwardingNumberE164"] = this.forwardingNumberE164 !== undefined ? this.forwardingNumberE164 : <any>null;
        data["allowIncomingMessages"] = this.allowIncomingMessages !== undefined ? this.allowIncomingMessages : <any>null;
        data["system"] = this.system !== undefined ? this.system : <any>null;
        data["portOutStatus"] = this.portOutStatus !== undefined ? this.portOutStatus : <any>null;
        data["authenticationName"] = this.authenticationName !== undefined ? this.authenticationName : <any>null;
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        return data;
    }
}

export interface ITelecomPhoneNumber {
    phoneNumberE164: string | null;
    forwardingNumberE164: string | null;
    allowIncomingMessages: boolean | null;
    system: string | null;
    portOutStatus: string | null;
    authenticationName: string | null;
    ownerId: number;
}

export class TelecomPhoneNumberPaginationResult implements ITelecomPhoneNumberPaginationResult {
    items!: TelecomPhoneNumber[] | null;
    count!: number;

    constructor(data?: ITelecomPhoneNumberPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TelecomPhoneNumber.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
        }
    }

    static fromJS(data: any): TelecomPhoneNumberPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new TelecomPhoneNumberPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        data["count"] = this.count !== undefined ? this.count : <any>null;
        return data;
    }
}

export interface ITelecomPhoneNumberPaginationResult {
    items: TelecomPhoneNumber[] | null;
    count: number;
}

export class UpdateGlobalOptInOutRequest implements IUpdateGlobalOptInOutRequest {
    ownerId!: number;
    phoneNumberE164!: string | null;
    isOptedOut!: boolean;

    constructor(data?: IUpdateGlobalOptInOutRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            this.phoneNumberE164 = _data["phoneNumberE164"] !== undefined ? _data["phoneNumberE164"] : <any>null;
            this.isOptedOut = _data["isOptedOut"] !== undefined ? _data["isOptedOut"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateGlobalOptInOutRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGlobalOptInOutRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        data["phoneNumberE164"] = this.phoneNumberE164 !== undefined ? this.phoneNumberE164 : <any>null;
        data["isOptedOut"] = this.isOptedOut !== undefined ? this.isOptedOut : <any>null;
        return data;
    }
}

export interface IUpdateGlobalOptInOutRequest {
    ownerId: number;
    phoneNumberE164: string | null;
    isOptedOut: boolean;
}

export class UpdatePhoneRequest implements IUpdatePhoneRequest {
    ownerId!: number;
    phoneNumberE164!: string | null;
    forwardingNumberE164!: string | null;
    allowIncomingMessages!: boolean;

    constructor(data?: IUpdatePhoneRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            this.phoneNumberE164 = _data["phoneNumberE164"] !== undefined ? _data["phoneNumberE164"] : <any>null;
            this.forwardingNumberE164 = _data["forwardingNumberE164"] !== undefined ? _data["forwardingNumberE164"] : <any>null;
            this.allowIncomingMessages = _data["allowIncomingMessages"] !== undefined ? _data["allowIncomingMessages"] : <any>null;
        }
    }

    static fromJS(data: any): UpdatePhoneRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePhoneRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        data["phoneNumberE164"] = this.phoneNumberE164 !== undefined ? this.phoneNumberE164 : <any>null;
        data["forwardingNumberE164"] = this.forwardingNumberE164 !== undefined ? this.forwardingNumberE164 : <any>null;
        data["allowIncomingMessages"] = this.allowIncomingMessages !== undefined ? this.allowIncomingMessages : <any>null;
        return data;
    }
}

export interface IUpdatePhoneRequest {
    ownerId: number;
    phoneNumberE164: string | null;
    forwardingNumberE164: string | null;
    allowIncomingMessages: boolean;
}